import { ReactNode } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import classNames from "classnames";
import ErrorMessage from "../ErrorMessage";
import styles from "./index.module.scss";
import Checkbox from "../Checkbox";

type PropsType = {
  section?: string;
  name: string;
  options: Array<{
    label: string;
    value: string;
    tooltip?: ReactNode;
    link?: ReactNode;
  }>;
  horizontal?: boolean;
  label?: string;
  disabled?: boolean;
  requiredText?: string;
  tooltip?: ReactNode;
  readOnly?: boolean;
};

const CheckboxGroup = ({
  section,
  name,
  requiredText,
  options,
  disabled,
  horizontal,
  label,
  tooltip,
  readOnly,
}: PropsType) => {
  const {
    formState: { errors },
  } = useFormContext();

  const nameDotFormat = (() => {
    if (section) {
      return `${section}.${name}`;
    }
    return `${name}`;
  })();

  const error =
    section && errors[section] ? errors[section][name] : errors[name];

  const selectedValues = useWatch({ name: nameDotFormat });

  return (
    <div key={`${nameDotFormat}-div`}>
      {label && (
        <div key={`${nameDotFormat}-div-label`} className={styles.labelText}>
          {label} {tooltip}
        </div>
      )}
      {error && requiredText && (
        <div key={`${nameDotFormat}-div-error`}>
          <ErrorMessage field={nameDotFormat}>{requiredText}</ErrorMessage>
        </div>
      )}
      <fieldset
        key={`${nameDotFormat}-fieldset`}
        className={classNames(styles.radioGroupFieldset, {
          [styles.horizontal]: horizontal,
        })}
      >
        {options.map((option) => (
           <span key={option.value}>
            <Checkbox
              key={`${nameDotFormat}-${option.value}`}
              name={nameDotFormat}
              value={option.value}
              label={option.label}
              textLink={option.link}
              disabled={
                disabled ||
                (readOnly &&
                  (!selectedValues || // selectedValues can be false (if never touched), OR be an array of checked values
                    (selectedValues &&
                      !selectedValues?.includes(option.value))))
              }
              requiredText={requiredText}
              readOnly={
                readOnly &&
                (!selectedValues ||
                  (selectedValues && selectedValues?.includes(option.value)))
              }
              tooltip={option.tooltip}
            />
         </span>
       ))}
      </fieldset>
    </div>
  );
};

export default CheckboxGroup;
